/** Chuyển HTML legacy (Quill) → text thuần cho field mới */
export const stripHtmlToPlainText = (input) => {
    if (input == null) return '';
    if (typeof input !== 'string') return String(input);
    let text = input;
    if (!text.includes('<') && !text.includes('&')) return text.trim();

    text = text
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<\/div>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'");

    return text.replace(/\n{3,}/g, '\n\n').replace(/[ \t]+/g, ' ').trim();
};

/** Lấy URL ảnh đầu tiên trong HTML cũ (không nhét vào đoạn text) */
export const extractFirstImageUrlFromHtml = (html) => {
    if (!html || typeof html !== 'string') return '';
    const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
    return match ? match[1].trim() : '';
};

export const splitParagraphs = (text) => {
    const plain = stripHtmlToPlainText(text);
    if (!plain) return [];
    return plain.split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
};
